import calc from '../../requirement/api/apiStdRequirementCalc'

export default {
  ...calc,
}
